// Only metadata from an enabled native profile can introduce additional seats.
// This does not add a new engine or a selectable GBA link mode.
export function playerSeats(game) {
  const advertised = game?.profile?.controllers;
  const count = Number.isInteger(advertised) && advertised >= 1 && advertised <= 4 ? advertised : 2;
  return Array.from({ length: count }, (_, index) => index + 1);
}
export function seatDescription(game) {
  const names = playerSeats(game).map(seat => 'P' + seat);
  return names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + ' or ' + names[names.length - 1];
}
export function personalScreenAspect(game) {
  if (game?.mode === 'linked' && ['gb', 'gbc'].includes(game.system)) return '10 / 9';
  return game?.profile?.aspect || (['gb', 'gbc'].includes(game?.system) ? '10 / 9' : game?.system === 'gba' ? '3 / 2' : '4 / 3');
}
